/* eslint-disable react-refresh/only-export-components */
import { Input, type InputProps, type InputRef } from "antd";
import { forwardRef, memo } from "react";

export interface CustomInputProps extends InputProps {}

const CustomInput = forwardRef<InputRef, CustomInputProps>(
  ({ className = "", ...restParams }, ref) => {
    return (
      <Input
        {...restParams}
        ref={ref}
        className={`custom-input px-2 py-4 mt-6 ${className}`.trim()}
      />
    );
  },
);

CustomInput.displayName = "CustomInput";

export default memo(CustomInput);
